// InkMerge Phase 5.9.4 — Sticky bottom ATC controller for sacred PDPs.
// Loaded ONLY when template suffix is dtf-size / upload-clean / gang-sheet.
// Sacred templates byte-frozen — this is sidecar JS that:
//   1. Mirrors variant/price into the sticky bar when a size button is clicked.
//   2. Slides the bar in/out via IntersectionObserver tracking the in-page ATC.
//   3. On click of the sticky button, finds + clicks the real in-page ATC.
(function () {
  "use strict";

  function $(s, root) {
    return (root || document).querySelector(s);
  }
  function $all(s, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(s));
  }

  // --- Discover the variant button group + ATC for whichever sacred template ---
  // dtf-size:       .dtf-size-product__size-btn   (data-variant-id, data-price)
  // gang-sheet:     .sheet-size-btn               (data-variant-id, data-variant-price)
  // upload-clean:   no variant grid (file-upload only) — bar still mirrors single variant
  function getVariantButtons() {
    return $all(".dtf-size-product__size-btn, .sheet-size-btn");
  }
  function getInPageATC() {
    // Try sacred-template ATCs in priority order:
    return (
      $("[data-button-add-to-cart]") ||
      $("button[type='submit'][name='add']") ||
      $("form[action*='/cart/add'] button[type='submit']") ||
      $(".product-page__atc") ||
      $(".dtf-size-product__atc") ||
      $(".gang-sheet-product__atc")
    );
  }

  function init() {
    var bar = $("[data-inkmerge-sticky-atc]");
    if (!bar) return;

    var btnVariant = $("[data-inkmerge-sticky-variant]", bar);
    var btnPrice = $("[data-inkmerge-sticky-price]", bar);
    var btnAtc = $("[data-inkmerge-sticky-atc-btn]", bar);
    var realAtc = getInPageATC();

    // === Mirror variant clicks into sticky bar ===
    getVariantButtons().forEach(function (btn) {
      btn.addEventListener("click", function () {
        var price =
          btn.getAttribute("data-price") ||
          btn.getAttribute("data-variant-price") ||
          btn.textContent;
        if (price && btnPrice) btnPrice.textContent = price;
        var label =
          btn.getAttribute("data-variant-title") ||
          btn.textContent.trim().toUpperCase();
        if (label && btnVariant) btnVariant.textContent = label;
      });
    });

    // === Click sticky → click real ATC ===
    if (btnAtc) {
      btnAtc.addEventListener("click", function (e) {
        e.preventDefault();
        var target = realAtc || getInPageATC();
        if (target && typeof target.click === "function") {
          target.click();
        } else {
          // Fallback: submit the cart-add form directly
          var form = $("form[action*='/cart/add']");
          if (form) form.submit();
        }
      });
    }

    // === Show / hide based on whether the in-page ATC is visible ===
    if (!realAtc || !("IntersectionObserver" in window)) {
      // No ATC anchor or no IO — show the bar always once user scrolled past 30vh
      var threshold = window.innerHeight * 0.3;
      window.addEventListener(
        "scroll",
        function () {
          if (window.scrollY > threshold) {
            document.body.classList.add("inkmerge-show-sticky-atc");
            bar.classList.add("is-visible");
          } else {
            document.body.classList.remove("inkmerge-show-sticky-atc");
            bar.classList.remove("is-visible");
          }
        },
        { passive: true },
      );
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Real ATC visible → hide sticky
            bar.classList.remove("is-visible");
            document.body.classList.remove("inkmerge-show-sticky-atc");
          } else {
            // Real ATC out of view → show sticky
            // But only if user scrolled past it (not above)
            if (entry.boundingClientRect.top < 0) {
              bar.classList.add("is-visible");
              document.body.classList.add("inkmerge-show-sticky-atc");
            }
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0 },
    );
    io.observe(realAtc);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// InkMerge gang-sheet launch guard.
// Keeps the legacy third-party builder block from opening and routes the CTA
// into the first-party InkMerge builder section instead.
(function () {
  "use strict";

  if (!document.body || !document.body.classList.contains("template--product.gang-sheet")) return;

  var buttonTextPattern = /build\s+your\s+own\s+gang\s+sheet/i;

  function getBuilderViewUrl() {
    var variantInput = document.getElementById("product-variant-id");
    var variantId = variantInput && variantInput.value ? variantInput.value : "";
    var url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set("view", "gang-sheet-builder-v2");
    if (variantId) url.searchParams.set("variant", variantId);
    url.searchParams.set("gsb", "20260605b");
    return url.pathname + url.search;
  }

  function normalizeBuilderUrl(builderUrl) {
    var url = new URL(builderUrl || getBuilderViewUrl(), window.location.origin);
    url.searchParams.set("view", "gang-sheet-builder-v2");
    url.searchParams.set("gsb", "20260605b");
    var variantInput = document.getElementById("product-variant-id");
    if (variantInput && variantInput.value) url.searchParams.set("variant", variantInput.value);
    return url.pathname + url.search;
  }

  function syncBuilderLaunch(launch) {
    if (!launch) return;
    var builderUrl = normalizeBuilderUrl(launch.getAttribute("data-builder-url") || launch.getAttribute("href"));
    launch.setAttribute("href", builderUrl);
    launch.setAttribute("data-builder-url", builderUrl);
  }

  function replaceOldBuilderButton() {
    var oldButton = document.querySelector("#gs-builder-btn, .gs--button");
    if (!oldButton) {
      syncBuilderLaunch(document.getElementById("inkmerge-builder-launch"));
      return;
    }
    if (oldButton.id === "inkmerge-builder-launch") {
      syncBuilderLaunch(oldButton);
      return;
    }

    var launch = document.createElement("a");
    launch.id = "inkmerge-builder-launch";
    launch.className = "inkmerge-builder-launch";
    launch.href = getBuilderViewUrl();
    launch.setAttribute("data-builder-url", getBuilderViewUrl());
    launch.textContent = "Build your own Gang Sheet";
    launch.style.cssText = [
      "width:100%",
      "min-height:48px",
      "border:0",
      "border-radius:0",
      "background:#000",
      "color:#fff",
      "font:700 16px/1.2 system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
      "cursor:pointer"
    ].join(";");

    oldButton.replaceWith(launch);
  }

  function navigateToBuilder(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var control = event.target.closest("a, button, [role='button'], input[type='button'], input[type='submit'], .gs--button");
    window.location.href = normalizeBuilderUrl(control && control.getAttribute("data-builder-url"));
  }

  function initGangSheetLaunchGuard() {
    replaceOldBuilderButton();
  }

  document.addEventListener("click", function (event) {
    var control = event.target.closest("a, button, [role='button'], input[type='button'], input[type='submit'], .gs--button");
    if (!control) return;
    var label = control.textContent || control.value || control.getAttribute("aria-label") || "";
    if (buttonTextPattern.test(label)) navigateToBuilder(event);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGangSheetLaunchGuard);
  } else {
    initGangSheetLaunchGuard();
  }

  window.setTimeout(initGangSheetLaunchGuard, 300);
  window.setTimeout(initGangSheetLaunchGuard, 1000);
  window.setTimeout(initGangSheetLaunchGuard, 2500);
})();
